// @ts-nocheck
/**
 * I18n Provider Component
 * Wraps the application with internationalization context
 */

import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Loading } from '@carbon/react';
import i18n from '../../i18n/config';
import { detectUserLanguage } from '../../i18n/config';
import type { SupportedLanguage } from '../../../../shared/interfaces/i18n.interface';

interface I18nProviderProps {
  children: React.ReactNode;
  defaultLanguage?: SupportedLanguage;
  detectLocation?: boolean;
}

const I18nProvider: React.FC<I18nProviderProps> = ({ children, defaultLanguage, detectLocation = true }) => {
  const [isReady, setIsReady] = useState(false);
  const [detectedLanguage, setDetectedLanguage] = useState<SupportedLanguage | null>(null);

  useEffect(() => {
    // Immediate initialization without any async operations to prevent hanging
    try {
      const clientLanguage = detectUserLanguage();
      setDetectedLanguage(clientLanguage);
      // Set language synchronously without waiting
      i18n.changeLanguage(clientLanguage);
      console.info('[I18n] Fast initialization complete with bundled translations');
    } catch (error) {
      console.warn('[I18n] Fallback to default language:', error);
    }

    // Set ready immediately - no async waiting
    setIsReady(true);
  }, [defaultLanguage, detectLocation]);

  // Show loading while i18n initializes
  if (!isReady) {
    return (
      <div
        className="i18n-loading"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <Loading description="Loading language resources..." withOverlay={false} />
        {detectedLanguage && (
          <p style={{ color: '#525252', fontSize: '14px' }}>
            Detected language: {detectedLanguage === 'pt' ? 'Português' : 'English'}
          </p>
        )}
      </div>
    );
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default I18nProvider;
